import LinkFactory from '../../../../components/LinkFactory/index.js'
import {WHATSAPP_LEAD_EXPERIENCE_VARIANTS} from './settings.js'

export const CURRENT_YEAR = new Date().getFullYear()

export const MAX_YEARS_OLD = 10

export const getHasPriceWithinFinancingRange = price => {
  return price >= 1667 && price <= 70000
}

export const getLinkFactoryWithState =
  ({multiProvinceTrackingData}) =>
  props =>
    <LinkFactory {...props} state={{provinces: multiProvinceTrackingData}} />

export const getFinancingData = ({ad, financingData, state}) => {
  const {hasCalculatedFinancingData, calculatedFinancingData} = state
  return {
    cashPrice: ad.price,
    financedPrice: hasCalculatedFinancingData ? calculatedFinancingData.computedPrice : ad.financedPrice,
    ...financingData,
    ...(hasCalculatedFinancingData && {
      ...calculatedFinancingData
    }),
    hasCalculatedFinancingData
  }
}

// ff_web_lead_experience_whatsapp_label_buttons
export const getIsWhatsappLoginRequiredVariant = variant => variant === WHATSAPP_LEAD_EXPERIENCE_VARIANTS.LOGIN_REQUIRED

export const getHasPhoneCallLabelVariant = variant =>
  variant === WHATSAPP_LEAD_EXPERIENCE_VARIANTS.NO_LOGIN_WITH_PHONE_CALL_LABEL

export const saveLeadEnrichmentToLocalStorage = ({localStorage, leadEnrichmentValue, key}) => {
  const existingData = localStorage.getItem(key)
  if (existingData) {
    const parsedData = JSON.parse(existingData)
    const mergeLeadEnrichmentValue = {leadEnrichmentValue, ...parsedData}
    localStorage.setItem(key, JSON.stringify(mergeLeadEnrichmentValue))
    return
  }
  const currentDataKeyValue = {leadEnrichmentValue}
  localStorage.setItem(key, JSON.stringify(currentDataKeyValue))
}
